import { SuggestionsList } from './suggestions-list';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  SponsoredProductsItems,
  SponsoredProductsItemsProps,
} from './sponsored-list/sponsored-products-items';

type SponsoredProductsListProps = SponsoredProductsItemsProps & {
  isKzDomain: boolean;
  suggestionSelector: string;
  withDivider: boolean;
};

export const SponsoredProductsList: React.FC<SponsoredProductsListProps> = ({
  isKzDomain,
  suggestionSelector,
  withDivider,
  sponsoredProducts,
  ...itemsProps
}) => {
  const { t } = useTranslation();

  if (isKzDomain || sponsoredProducts.length === 0) return null;

  return (
    <SuggestionsList
      suggestionSelector={suggestionSelector}
      withTitle={false}
      withDivider={withDivider}
      title={t('header.searchbar.sponsored')}
      aria-label={t('header.searchbar.sponsored-aria')}
      data-qa={'sponsored-product-suggestions'}
    >
      <SponsoredProductsItems sponsoredProducts={sponsoredProducts} {...itemsProps} />
    </SuggestionsList>
  );
};
